import Header from "../../components/Header/Header"
import Footer from "../../components/Footer/Footer"
import { HeaderType } from "../../components/Header/types/Header"
import { FooterType } from "../../components/Footer/types/Footer"
import styles from './ProjectStatusPage.module.css'
import Button from "../../components/UI/Button/Button"
import PreviewImage from '../../assets/images/ProjectStatusPage/PreviewImage.webp'
import cn from "classnames"
import ProjectOneImage from '../../assets/images/ProjectStatusPage/FirstOne.webp'
import ProjectTwoImage from '../../assets/images/ProjectStatusPage/FirstTwo.webp'
import ProjectThreeImage from '../../assets/images/ProjectStatusPage/FirstThree.webp'
import ProjectFourImage from '../../assets/images/ProjectStatusPage/FirstFour.webp'
import ServiceOneImage from '../../assets/images/ProjectStatusPage/ServiceOne.webp'
import ServiceTwoImage from '../../assets/images/ProjectStatusPage/ServiceTwo.webp'
import ServiceThreeImage from '../../assets/images/ProjectStatusPage/ServiceThree.webp'
import ServiceFourImage from '../../assets/images/ProjectStatusPage/ServiceFour.webp'
import ServiceFiveImage from '../../assets/images/ProjectStatusPage/ServiceFive.webp'
import MapImage from '../../assets/images/ProjectStatusPage/Map.webp'
import { Helmet } from "react-helmet"
import DocumentCard, { DocumentsData } from "../../components/DocumentCard/DocumentCard"
import TabButton from "../../components/UI/TabButton/TabButton"
import { useContext, useEffect, useState } from "react"
import Loader from "../../components/Loader/Loader"
import { LoaderContext } from "../../components/Loader/LoaderContext"
import { motion } from "framer-motion"
import PhoneCallModal from "../../components/PhoneCallModal/PhoneCallModal"
import api from "../../utils/api"
import { transformDocuments } from "../../utils/transformers"

export default function ProjectStatusPage() {
  const [documentsData, setDocumentsData] = useState<DocumentsData[]>([]);
  const [selectedType, setSelectedType] = useState<string | null>('Проектная декларация');
  const { isInitialLoad, setIsInitialLoad } = useContext(LoaderContext);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isPhoneModalActive, setIsPhoneModalActive] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add('black');
    document.body.classList.add('black');

    return () => {
      document.documentElement.classList.remove('black');
      document.body.classList.remove('black');
    };
  }, []);

  const updateWindowWidth = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth);
    return () => {
      window.removeEventListener('resize', updateWindowWidth);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.documents.getAll();
        const transformedResponse = await transformDocuments(response);
        const uniqueDocs = Array.from(new Map(transformedResponse.map(doc => [doc.file, doc])).values());
        setDocumentsData(uniqueDocs);
      }
      finally {
        setIsInitialLoad(false);
      }
    }
    fetchData();
  }, [setIsInitialLoad]);

  const handleTypeClick = (type: string) => {
    setSelectedType((prevType) => (prevType === type ? null : type));
  };

  const filteredDocs = documentsData.filter((docs) => {
    const matchesType = docs.type === selectedType;
    return matchesType;
  });

  const documentsTypes = ['Проектная декларация', 'Разрешительная документация', 'Проектная документация'];

  const reversedDocs = [...filteredDocs].reverse();

  const buttonStyle = {
    width: windowWidth <= 576 ? '100%' : 'fit-content',
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = MapImage;
    link.download = 'Презентация';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const handlePhoneModalClose = () => {
    setIsPhoneModalActive(false);
  };

  return (
    <>
      <Helmet>
        <title>Статус | Восток Строй</title>
        <meta name="description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="keywords" content="недвижимость, девелопер, Каспийск, новостройки, квартиры" />
        <meta name="author" content="Восток Строй" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vostokstroy.com/projects/status" />

        <meta property="og:title" content="Умный проект премиум-класса | Восток Строй" />
        <meta property="og:description" content="Уровень обслуживания, не имеющий аналогов во всем Дагестане" />
        <meta property="og:image" content="https://vostokstroy.com/open-graphs/status-opengraph.jpg" />
        <meta property="og:url" content="https://vostokstroy.com/projects/status" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Восток Строй" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Умный проект премиум-класса | Восток Строй" />
        <meta name="twitter:description" content="Уровень обслуживания, не имеющий аналогов во всем Дагестане" />
        <meta name="twitter:image" content="https://vostokstroy.com/open-graphs/status-opengraph.jpg" />

        <link rel="icon" type="image/svg+xml" href="/favicons/status-fav-32x32.svg" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/status-fav-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/status-fav-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/status-apple-touch-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="180x180" href="/favicons/status-fav-180x180.png" />
      </Helmet>
      {isInitialLoad ? (
        <Loader />
      ) : (
        <>
      <div className={styles.project_status_wrapper}>
        <Header theme={HeaderType.Dark}></Header>
        <motion.div 
          className={styles.preview_image_wrapper}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <img src={PreviewImage} alt="Статус" />
        </motion.div>
        <div className={styles.project_wrapper}>
          <motion.div 
            className={styles.project_text_wrapper}
            {...fadeInUp}
          >
            <div className={styles.project_title}>
              <h1>Умный проект премиум-класса</h1>
            </div>
            <div className={cn('text-1_font', styles.project_description)}>
              <p>Уровень обслуживания, не имеющий аналогов во всем Дагестане</p>
            </div>
          </motion.div>
          <motion.div {...fadeInUp}>
            <Button roundType="small_rounded" onClick={() => setIsPhoneModalActive(true)}>Созвониться с менеджером</Button>
          </motion.div>
          <motion.div 
            className={styles.project_images_wrapper}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className={cn(styles.project_image_item, styles.project_image_wide)}>
              <img src={ProjectOneImage} alt='Изображение проекта "Статус"' />
            </div>
            <div className={styles.project_image_item}>
              <img src={ProjectTwoImage} alt='Изображение проекта "Статус"' />
            </div>
            <div className={styles.project_image_item}>
              <img src={ProjectThreeImage} alt='Изображение проекта "Статус"' />
            </div>
            <div className={cn(styles.project_image_item, styles.project_image_wide)}>
              <img src={ProjectFourImage} alt='Изображение проекта "Статус"' />
            </div>
          </motion.div>
          <motion.div 
            className={cn(styles.content_wrapper, styles.services_wrapper)}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className={styles.services_images_wrapper}>
              <div className={styles.services_main_image_wrapper}>
                <div>
                  <img src={ServiceOneImage} alt="Изображение мобильного приложения" />
                </div>
                <div className={cn('caption-1_font', styles.services_image_description)}>
                  <span>Мобильное приложение</span>
                </div>
              </div>
              <div className={styles.services_grid_images_wrapper}>
                <div className={cn(styles.services_grid_item, styles.services_grid_tall)}>
                  <div className={styles.services_grid_two}>
                    <img src={ServiceTwoImage} alt="Изображение спортзала с бассейном" />
                  </div>
                  <div className={cn('caption-1_font', styles.services_image_description)}>
                    <span>Спортзал с бассейном</span>
                  </div>
                </div>
                <div className={cn(styles.services_grid_item)}>
                  <div className={styles.services_grid_three}>
                    <img src={ServiceThreeImage} alt="Изображение ресторана" />
                  </div>
                  <div className={cn('caption-1_font', styles.services_image_description)}>
                    <span>Ресторан</span>
                  </div>
                </div>
                <div className={cn(styles.services_grid_item)}>
                  <div className={styles.services_grid_four}>
                    <img src={ServiceFourImage} alt="Изображение детского сада" />
                  </div>
                  <div className={cn('caption-1_font', styles.services_image_description)}>
                    <span>Детский сад</span>
                  </div>
                </div>
                <div className={cn(styles.services_grid_item, styles.services_grid_tall, styles.services_grid_wide)}>
                  <div>
                    <img src={ServiceFiveImage} alt="Изображение парковки с автомойкой, детейлингом и шиномонтажем" />
                  </div>
                  <div className={cn('caption-1_font', styles.services_image_description)}>
                    <span>Парковка с автомойкой, детейлингом и шиномонтажем</span>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.services_text_wrapper}>
              <div className={styles.services_text_title}>
                <h3>Сервис</h3>
              </div>
              <div className={cn('text-2_font', styles.services_text_description)}>
                <p>Вокруг «Статуса» — круглосуточные магазины, кафе, рестораны, детские сады со школами и развлекательные заведения.</p>
              </div>
              <div className={cn('text-2_font', styles.services_text_description)}>
                <p>Вокруг «Статуса» — круглосуточные магазины, кафе, рестораны, детские сады со школами и развлекательные заведения.</p>
              </div>
            </div>
          </motion.div>
          <motion.div 
            className={cn(styles.content_wrapper, styles.map_wrapper)}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className={styles.map_text_wrapper}>
              <div className={styles.map_text_title}>
                <h3>Местоположение</h3>
              </div>
              <div className={cn('text-2_font', styles.map_text_description)}>
                <p>Вокруг «Статуса» — круглосуточные магазины, кафе, рестораны, детские сады со школами и развлекательные заведения</p>
              </div>
            </div>
            <div className={styles.map_image_wrapper}>
              <img src={MapImage} alt="" />
            </div>
            <a
              href="https://yandex.ru/maps/-/CHXarDoU"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <Button width="fit-content" roundType="small_rounded" colorType="dark_gray">
                Открыть на карте
              </Button>
            </a>
          </motion.div>
          <motion.div 
            className={styles.presentation_wrapper}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className={styles.text_title}>
              <h3>Презентация проекта</h3>
              <p>Полезно для сохранения информации о&nbsp;проекте</p>
            </div>
            <Button width='fit-content' roundType='small_rounded' onClick={handleDownload} style={buttonStyle}>Скачать {' '}<span className={styles.button_file_size}>2,3 мб</span></Button>
          </motion.div>
          <motion.div 
            className={styles.documents_wrapper}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className={styles.documents_header}>
              <h3>Документация</h3>
              <p className='text_body_b2'>Весь проект прозрачен. Мы&nbsp;опубликовали все документы, которые у&nbsp;нас есть. Проверить их&nbsp;соответствие с&nbsp;реальностью возможно на&nbsp;ДОМ.РФ</p>
            </div>
            <div className={styles.documents_content}>
              <div className={styles.documents_filter}>
                {documentsTypes.map((tab, index) => (
                  <TabButton
                    key={index}
                    isActive={selectedType === tab}
                    onClick={() => handleTypeClick(tab)}
                    theme="dark"
                  >
                    {tab}
                  </TabButton>
                ))}
              </div>
              <div className={styles.documents_list}>
                {reversedDocs.map((data, index) => (
                  <DocumentCard
                    key={index}
                    type={data.type}
                    date={data.date}
                    title={data.title}
                    file={data.file}
                  />
                ))}
              </div>
            </div>
          </motion.div>
        </div>
        <Footer theme={FooterType.Dark}></Footer>
        <PhoneCallModal isActive={isPhoneModalActive} onClose={handlePhoneModalClose} />
      </div>
      </>
      )}
    </>
  )
}
